export const isInE2ETest = typeof window !== "undefined" && !!window.Cypress;
